module.exports = __webpack_public_path__ + "img/child_education_logo.6d6c30e2.webp";